import {inject, observer} from 'mobx-react';
import './index.scss';
import Slide from '../Slide';
@inject(({store}) => {
    const {renderData} = store;
    const {handbook = [], lysc = []} = renderData;
    return {
        requestData: store.requestData,
        handbook,
        lysc
    };
})
@observer
class Book extends React.Component {
    state = {
        showTip: true,
        showModal: false,
        activeIndex: 1
    }

    componentDidMount() {
        this.props.requestData();
    }

    closeTip = () => {
        this.setState({
            showTip: false
        });
    }

    toggleModal = () => {
        this.closeTip();
        this.setState({
            showModal: !this.state.showModal
        });
    }

    indexChange = (type) => {
        const {activeIndex} = this.state;
        const {handbook = []} = this.props;
        this.click = true;
        if(activeIndex === 1 && type === 'subtract' || activeIndex === handbook.length && type === 'plus') return;
        let newIndex = activeIndex + (type === 'subtract' ? -1 : 1);
        this.setState({
            activeIndex: newIndex
        }, () => {
            this.slider.slickGoTo(newIndex - 1);
            this.closeTip();
        });
    }

    render() {
        const {showModal, showTip, activeIndex} = this.state;
        const {handbook = [], lysc = [], match = {}} = this.props;
        const {params: {type = ''} = {}} = match;
        const bookList = type === 'camp' ? lysc : handbook;

        return (
            <div className="m-book g-flexbox-column">
                <div className="pics">
                    <Slide setting={{dots: false, infinite: false, onSwipe: () => {
                        this.closeTip();
                    }, afterChange: index => {
                        this.setState({
                            activeIndex: index + 1
                        });
                        this.closeTip();
                    }}} getRef={(ele) => {
                        this.slider = ele;
                    }}>
                        {
                            bookList.map((item, index) => {
                                return (
                                    <img src={item.images} key={index}/>
                                );
                            })
                        }
                    </Slide>
                </div>
                {showModal && <div className="modal">
                    <div className="modal-cont g-flexbox-column">
                        <div className="close yo-ico" onClick={this.toggleModal}>&#xf3f4;</div>
                        <div className="tit">选择页码</div>
                        <div className="pages">
                            {
                                bookList.map((item, index) => {
                                    return (
                                        <div className={`item ${activeIndex - 1 === index ? 'active' : ''}`} onClick={() => {
                                            this.slider.slickGoTo(index);
                                            this.setState({
                                                activeIndex: index + 1
                                            }, () => {
                                                this.toggleModal();
                                            });
                                        }}>{index < 9 ? `0${index+1}` : index+1}</div>
                                    );
                                })
                            }
                        </div>
                    </div>
                </div>}
                <div className="indicate g-flexbox">
                    {showTip && <div className="tips g-flexbox">Tips：左右滑动可翻页浏览/点击页码可选择页数<span className="yo-ico" onClick={this.closeTip}>&#xf3f4;</span></div>}
                    <div className="cont g-flexbox">
                        <div className={`prev ${activeIndex === 1 ? 'disabled' : ''} yo-ico`} onClick={() => {
                            this.indexChange('subtract');
                        }}>&#xe655;</div>
                        <div className="num" onClick={this.toggleModal}><span>{activeIndex <= 9 ? `0${activeIndex}` : activeIndex}</span>/{bookList.length}</div>
                        <div className={`next ${activeIndex === bookList.length ? 'disabled' : ''} yo-ico`} onClick={() => {
                            this.indexChange('plus');
                        }}>&#xe655;</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Book;